export const getCsvDownloadUrl = (headers: string[], content: (string | number)[][], separator: string) => {
  const csvContent = content.map((row) => row.join(separator));
  const csvHeader = headers.join(separator);
  csvContent.unshift(csvHeader);
  const csvContentStr = csvContent.join("\n");

  const file = new Blob([csvContentStr], { type: `data:text/csv;charset=utf-8${` ${separator}`} ` });
  return URL.createObjectURL(file);
};
